import * as React from "react"
import { PopupButton } from "react-calendly"
export const CompletedProject = () => {
  const [rootElement, setRootElement] = React.useState<HTMLElement | null>(null)

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const element = document.getElementById("___gatsby")
      setRootElement(element)
    }
  }, [])
  return (
    <div className="bg-completedProject py-10 mt-14">
      <div className="container mx-auto">
        <div className="flex lg:flex-row flex-col justify-between gap-10">
          <div className="lg:w-1/3 px-5 lg:px-5">
            <div className="flex text-gray gap-2 items-center">
              <div className="border border-color w-24 rounded-2xl text-center">
                <p className="py-1">3000</p>
              </div>
              <div className="w-8 h-8 rounded-full border border-color flex justify-center items-center">
                <p>+</p>
              </div>
            </div>
            <div>
              <p className="text-black text-xl font-semibold py-3">
                Completed Projects
              </p>
              <p className="text-gray text-sm">
                Explore our completed projects that showcase innovation,
                quality, and impact. Each project reflects our commitment to
                excellence and client success.
              </p>
            </div>
          </div>
          <div className="lg:w-1/3 px-5 lg:px-5">
            <div className="flex text-gray gap-2 items-center">
              <div className="border border-color w-24 rounded-2xl text-center">
                <p className="py-1">100%</p>
              </div>
              <div className="w-8 h-8 rounded-full border border-color flex justify-center items-center">
                <p>↑</p>
              </div>
            </div>
            <div>
              <p className="text-black text-xl font-semibold py-3">
                Faster Completion
              </p>
              <p className="text-gray text-sm">
                We ensure rapid project completion without compromising quality.
                Get your ideas to market faster with our efficient workflows and
                expert execution!
              </p>
            </div>
          </div>
          <div className="lg:w-1/3 px-5 lg:px-5">
            <div className="flex text-gray gap-2 items-center">
              <div className="border border-color w-24 rounded-2xl text-center">
                <p className="py-1">80%</p>
              </div>
              <div className="w-8 h-8 rounded-full border border-color flex justify-center items-center">
                <p>↓</p>
              </div>
            </div>
            <div>
              <p className="text-black text-xl font-semibold py-3">
                Cost Reduction
              </p>
              <p className="text-gray text-sm">
                Cost reduction is about cutting unnecessary expenses while
                enhancing efficiency. We help you streamline operations,
                maximize savings, and drive higher profitability!
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-4 pt-8">
          {rootElement && (
            <PopupButton
              className="px-6 py-3 bg-button-unique book-free-consultancy-radius text-black font-inter lg:text-sm text-xs whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in rounded-lg bg-btn bg-glass"
              url="https://calendly.com/visualfolio-info/30min"
              rootElement={rootElement}
              text="Book Your Free Consultancy"
            />
          )}
        </div>
      </div>
    </div>
  )
}
